export default "__VITE_ASSET__B2iyTr9B__"